<template>
  <div class="failed">
    <img src="../assets/img/verify/shibai1.png" alt />
    <p>内容加载失败</p>
    <p>请稍后重试</p>
    <div @click="handleClick">刷新</div>
  </div>
</template>

<script>
export default {
  methods: {
    handleClick() {
      this.$router.go(0);
    },
  },
};
</script>

<style scoped lang="scss">
.failed {
  margin-top: 63px;
  img {
    width: 222px;
    height: 222px;
    margin-bottom: 5px;
    border: 1px;
  }
  p {
    font-size: 14px;
    text-align: center;
    color: #999999;
    letter-spacing: 0px;
  }
  div {
    margin: 0 auto;
    margin-top: 35px;

    width: 285px;
    height: 50px;
    background: #07d1aa;
    border-radius: 8px;
    line-height: 50px;
    font-size: 16px;
    color: #ffffff;
  }
}
img {
  object-fit: cover;
}
</style>